module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/card/components/card-main.component.html
// module id = 2195
// module chunks = 20